module.exports = __webpack_public_path__ + "static/img/打造品牌医生IP@2x.1159f283.png";